export default (function (pluginState, action) {
  return pluginState;
});